export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="page-wrap footer-inner">
        <p>
          &copy; {year} Bookling by <a href="https://blog.thomaub.dev/">Thomaub.</a>
        </p>
      </div>
    </footer>
  );
}
